(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("FiltersFlyersController", FiltersFlyersController);

    /** @ngInject */
    function FiltersFlyersController(
        $uibModalInstance,
        $translate,
        $localStorage,
        moment,
        filters,
        options,
        list,
        isImmoContext,
        paginationConstants,
        StoreService,
        flyersConstants
    ) {
        const DATE_FORMAT = $translate.instant("momentDateFormat");
        var vm = this;

        if (options.isBagFilter && filters) {
            if (filters.colors && filters.colors.length > 0) {
                filters.colors = filters.colors.map(function (color) {
                    if (typeof color === 'string') {
                        var matchingColor = options.colors.find(function (c) {
                            return c.label === color;
                        });
                        return {
                            label: color,
                            id: matchingColor ? matchingColor.id : options.colors.indexOf(color) + 1
                        };
                    }
                    return color;
                });
            }

            if (filters.sizes && filters.sizes.length > 0) {
                filters.sizes = filters.sizes.map(function (size) {
                    if (typeof size === 'string') {
                        var matchingSize = options.sizes.find(function (s) {
                            return s.label === size;
                        });
                        return {
                            label: size,
                            id: matchingSize ? matchingSize.id : options.sizes.indexOf(size) + 1
                        };
                    }
                    return size;
                });
            }

            if (filters.tags && filters.tags.length > 0) {
                filters.tags = filters.tags.map(function (tag) {
                    if (typeof tag === 'string') {
                        var matchingTag = options.tags.find(function (t) {
                            return t.label === tag;
                        });
                        return {
                            label: tag,
                            id: matchingTag ? matchingTag.id : options.tags.indexOf(tag) + 1
                        };
                    }
                    return tag;
                });
            }
        }

        vm.originalFilters = angular.copy(filters);
        vm.filters = angular.copy(filters);
        vm.listFilter = list;
        vm.isImmoContext = isImmoContext;
        vm.sortOptions =
            paginationConstants.sortOptions[$translate.use().toLowerCase()];
        vm.dynamicFilterOptions = {
            categories: options.dynamicFilterOptions.categories || getDynamicFilterOptionsModel(),
            brands: options.dynamicFilterOptions.brands || getDynamicFilterOptionsModel(),
            colors: options.dynamicFilterOptions.colors || getDynamicFilterOptionsModel(),
            sizes: options.dynamicFilterOptions.sizes || getDynamicFilterOptionsModel()
        };
        vm.configurations = options.configurations;
        vm.bedrooms = options.bedrooms;
        vm.bathrooms = options.bathrooms;
        vm.parkingSpots = options.parkingSpots;
        vm.tags = options.tags;
        vm.hasInventory = filters.hasInventory;
        vm.itemsPerPageOptions = options.itemsPerPageOptions;
        vm.sortOptions = options.sortOptions;
        vm.numPerPage = options.numPerPage;
        vm.selectedSort = options.selectedSort;
        if (options.listCategoryFilterOptions) {
            vm.listCategoryFilterOptions = options.listCategoryFilterOptions;
        }
        if (options.listBrandFilterOptions) {
            vm.listBrandFilterOptions = options.listBrandFilterOptions;
        }
        if (options.listColorFilterOptions) {
            vm.listColorFilterOptions = options.listColorFilterOptions;
        }
        if (options.listSizeFilterOptions) {
            vm.listSizeFilterOptions = options.listSizeFilterOptions;
        }

        StoreService.getStore($localStorage.defaultStore.storeId).then(
            function (response) {
                vm.storeCategory = response.data.categoryKey;
            }
        );

        vm.genders = flyersConstants.SELECT_OPTIONS.RETAIL.GENDERS;
        vm.isHubContext = $localStorage.defaultStore.hubContext;

        vm.promotionalPriceOptions = [
            { label: 'flyers.filters.promotionalPrice.both', value: null },
            { label: 'flyers.filters.promotionalPrice.with', value: true },
            { label: 'flyers.filters.promotionalPrice.without', value: false }
        ];

        vm.isBagFilter = options.isBagFilter || false;
        if (vm.isBagFilter) {
            formatFilterOptions();
        }

        normalizePromotionalPriceFilter();

        function normalizePromotionalPriceFilter() {
            var promoPrice = vm.filters.hasPromotionalPrice;
            if (promoPrice !== null && promoPrice !== undefined && typeof promoPrice !== 'object') {
                vm.filters.hasPromotionalPrice = vm.promotionalPriceOptions.find(function(opt) {
                    return opt.value === promoPrice;
                }) || null;
            } else if (promoPrice === null || promoPrice === undefined) {
                vm.filters.hasPromotionalPrice = null;
            }
        }

        vm.closeModal = function (response, applyFilters) {
            if (!applyFilters) {
                vm.filters = vm.originalFilters;
            }
            $uibModalInstance.close(response);
        };

        vm.clearFilters = function () {
            vm.filters.region = [];
            vm.filters.categories = [];
            vm.filters.brands = [];
            vm.filters.colors = [];
            vm.filters.sizes = [];
            vm.filters.genders = [];
            vm.filters.bedrooms = [];
            vm.filters.bathrooms = [];
            vm.filters.parkingSpots = [];
            vm.filters.minValue = null;
            vm.filters.maxValue = null;
            vm.filters.minMeters = null;
            vm.filters.maxMeters = null;
            vm.filters.sinceDate = null;
            vm.filters.untilDate = null;
            vm.filters.configurations = [];
            vm.filters.tags = [];
            vm.hasInventory = false;
            vm.filters.hasPromotionalPrice = null;
            vm.filters.sortSelected = {
                value: "lastModifiedDate",
                direction: "desc",
            };
        };

        vm.applyFilters = function () {
            var filters = angular.copy(vm.filters);
            filters.region = (filters.region || []).map(function (region) {
                return region.polygons;
            });
            filters.categories = (filters.categories || []).map(function (
                category
            ) {
                return category.key;
            });
            filters.brands = (filters.brands || []).map(function (brand) {
                return brand.name;
            });
            filters.colors = (filters.colors || []).map(function (color) {
                return color.label;
            });
            filters.sizes = (filters.sizes || []).map(function (size) {
                return size.label;
            });
            filters.genders = (filters.genders || []).map(function (gender) {
                return gender.id;
            });
            filters.bedrooms = (filters.bedrooms || []).map(function (bedroom) {
                return bedroom.value;
            });
            filters.bathrooms = (filters.bathrooms || []).map(function (
                bathroom
            ) {
                return bathroom.value;
            });
            filters.parkingSpots = (filters.parkingSpots || []).map(function (
                parking
            ) {
                return parking.value;
            });
            filters.configurations = (filters.configurations || []).map(
                function (configuration) {
                    return configuration.code;
                }
            );
            filters.sortDirection = filters.sortSelected
                ? filters.sortSelected.direction
                : "desc";
            filters.sortBy = filters.sortSelected
                ? filters.sortSelected.value
                : "lastModifiedDate";

            if (filters.region.length > 0) {
                vm.listFilter.region = filters.region;
            } else {
                vm.listFilter.region = [];
            }

            if (filters.categories.length > 0) {
                vm.listFilter.categoryKeys = filters.categories;
                vm.listFilter.categoryKey = filters.categories[0];
            } else {
                delete vm.listFilter.categoryKey;
                vm.listFilter.categoryKeys = [];
            }

            if (filters.colors.length > 0) {
                vm.listFilter.colors = filters.colors;
            } else {
                vm.listFilter.colors = [];
            }

            if (filters.sizes.length > 0) {
                vm.listFilter.sizes = filters.sizes;
            } else {
                vm.listFilter.sizes = [];
            }

            if (filters.genders.length > 0) {
                vm.listFilter.genders = filters.genders;
            } else {
                vm.listFilter.genders = [];
            }

            if (filters.configurations.length > 0) {
                vm.listFilter.configurations = filters.configurations;
            } else {
                vm.listFilter.configurations = [];
            }

            if (filters.bedrooms.length > 0) {
                vm.listFilter.bedrooms = filters.bedrooms;
            } else {
                vm.listFilter.bedrooms = [];
            }

            if (filters.bathrooms.length > 0) {
                vm.listFilter.bathrooms = filters.bathrooms;
            } else {
                vm.listFilter.bathrooms = [];
            }

            if (filters.parkingSpots.length > 0) {
                vm.listFilter.parkingSpots = filters.parkingSpots;
            } else {
                vm.listFilter.parkingSpots = [];
            }

            if (filters.brands.length > 0) {
                vm.listFilter.brands = filters.brands;
                vm.listFilter.brand = filters.brands[0];
            } else {
                delete vm.listFilter.brand;
                vm.listFilter.brands = [];
            }

            if (filters.sortBy && filters.sortDirection) {
                vm.listFilter.sortBy = filters.sortBy;
                vm.listFilter.sortDirection = filters.sortDirection;
            } else {
                vm.listFilter.sortBy = "";
                vm.listFilter.sortDirection = "";
            }

            if (filters.minValue || filters.minValue !== "") {
                vm.listFilter.minValue = filters.minValue;
            } else {
                vm.listFilter.minValue = null;
            }

            if (filters.maxValue || filters.maxValue !== "") {
                vm.listFilter.maxValue = filters.maxValue;
            } else {
                vm.listFilter.maxValue = null;
            }

            if (filters.minMeters || filters.minMeters !== "") {
                vm.listFilter.minMeters = filters.minMeters;
            } else {
                vm.listFilter.minMeters = null;
            }

            if (filters.maxMeters || filters.maxMeters !== "") {
                vm.listFilter.maxMeters = filters.maxMeters;
            } else {
                vm.listFilter.maxMeters = null;
            }

            if (filters.sinceDate || filters.sinceDate !== "") {
                vm.listFilter.sinceDate = moment(
                    filters.sinceDate,
                    DATE_FORMAT
                ).toDate();
            } else {
                delete vm.listFilter.sinceDate;
                vm.listFilter.sinceDate = null;
            }

            if (filters.untilDate || filters.untilDate !== "") {
                vm.listFilter.untilDate = moment(
                    filters.untilDate,
                    DATE_FORMAT
                ).toDate();
            } else {
                delete vm.listFilter.untilDate;
                vm.listFilter.untilDate = null;
            }

            vm.listFilter.hasInventory = vm.hasInventory;
            vm.filters.hasInventory = vm.hasInventory;

            if (filters.hasPromotionalPrice && typeof filters.hasPromotionalPrice === 'object') {
                filters.hasPromotionalPrice = filters.hasPromotionalPrice.value;
            }
            vm.listFilter.hasPromotionalPrice = filters.hasPromotionalPrice;

            vm.closeModal(
                {
                    filtered: filters,
                    selectedFilters: angular.copy(vm.filters),
                    listFilter: vm.listFilter,
                    sortSelected: vm.selectedSort,
                    numPerPage: vm.numPerPage,
                    dynamicFilterOptions: vm.dynamicFilterOptions
                },
                true
            );
        };

        vm.onChangeItemsPerPage = function (newValue) {
            vm.numPerPage = newValue;
        };

        vm.onSelectedSortOption = function (newValue) {
            vm.selectedSort = newValue;
        };

        vm.getTranslateKey = function (key) {
            return getTranslateKey(vm.isImmoContext, key);
        }

        function formatFilterOptions() {
            if (vm.filters.categories) {
                var categories = [];
                vm.filters.categories.map(function (category) {
                    vm.dynamicFilterOptions.categories.forEach(function (configured_category) {
                        if (configured_category.key === category) {
                            categories.push({
                                label: configured_category.title,
                                id: configured_category.id,
                                title: configured_category.title,
                                key: category,
                            });
                        }
                    });
                });
                vm.filters.categories = categories;
            }

            if (vm.filters.sizes) {
                var sizes = [];
                vm.filters.sizes.map(function (size) {
                    vm.dynamicFilterOptions.sizes.forEach(function (sizeOption) {
                        if (angular.isString(size)) {
                            if (sizeOption.label === size) {
                                sizes.push({label: size, id: sizeOption.id});
                            }
                        } else {
                            if (sizeOption.label === size.label) {
                                sizes.push(sizeOption);
                            }
                        }
                    });
                });
                vm.filters.sizes = sizes;
            }

            if (vm.filters.brands) {
                var brands = [];
                vm.filters.brands.map(function (brand) {
                    vm.dynamicFilterOptions.brands.forEach(function (configured_brand) {
                        if (configured_brand.name === brand) {
                            brands.push({
                                name: brand,
                                label: brand,
                                id: configured_brand.id,
                            });
                        }
                    });
                });
                vm.filters.brands = brands;
            }

            if (vm.filters.colors) {
                var colors = [];
                vm.filters.colors.map(function (color) {
                    vm.dynamicFilterOptions.colors.forEach(function (colorOption) {
                        if (angular.isString(color)) {
                            if (colorOption.label === color) {
                                colors.push({label: color, id: colorOption.id});
                            }
                        } else {
                            if (colorOption.label === color.label) {
                                colors.push(colorOption);
                            }
                        }
                    });
                });
                vm.filters.colors = colors;
            }

            if (vm.filters.genders) {
                var genders = [];
                vm.filters.genders.map(function (gender) {
                    vm.genders.forEach(function (configured_gender) {
                        if (configured_gender.id === gender) {
                            genders.push({
                                label: configured_gender.label,
                                id: gender,
                            });
                        }
                    });
                });
                vm.filters.genders = genders;
            }

            if (vm.filters.tags) {
                var tags = [];
                vm.filters.tags.map(function (tag) {
                    vm.tags.forEach(function (tagOption) {
                        if (angular.isString(tag)) {
                            if (tagOption.label === tag) {
                                tags.push({label: tag, id: tagOption.id});
                            }
                        } else {
                            if (tagOption.label === tag.label) {
                                tags.push(tagOption);
                            }
                        }
                    });
                });
                vm.filters.tags = tags;
            }

            if (vm.filters.bedrooms) {
                var bedrooms = [];
                vm.filters.bedrooms.map(function (bedroom) {
                    vm.bedrooms.forEach(function (bedroomOption) {
                        if (angular.isNumber(bedroom)) {
                            if (bedroomOption.value === bedroom) {
                                bedrooms.push(bedroomOption);
                            }
                        } else {
                            if (bedroomOption.value === bedroom.value) {
                                bedrooms.push(bedroomOption);
                            }
                        }
                    });
                });
                vm.filters.bedrooms = bedrooms;
            }

            if (vm.filters.bathrooms) {
                var bathrooms = [];
                vm.filters.bathrooms.map(function (bathroom) {
                    vm.bathrooms.forEach(function (bathroomOption) {
                        if (angular.isNumber(bathroom)) {
                            if (bathroomOption.value === bathroom) {
                                bathrooms.push(bathroomOption);
                            }
                        } else {
                            if (bathroomOption.value === bathroom.value) {
                                bathrooms.push(bathroomOption);
                            }
                        }
                    });
                });
                vm.filters.bathrooms = bathrooms;
            }

            if (vm.filters.parkingSpots) {
                var parkingSpots = [];
                vm.filters.parkingSpots.map(function (parkingSpot) {
                    vm.parkingSpots.forEach(function (parkingSpotOption) {
                        if (angular.isNumber(parkingSpot)) {
                            if (parkingSpotOption.value === parkingSpot) {
                                parkingSpots.push(parkingSpotOption);
                            }
                        } else {
                            if (parkingSpotOption.value === parkingSpot.value) {
                                parkingSpots.push(parkingSpotOption);
                            }
                        }
                    });
                });
                vm.filters.parkingSpots = parkingSpots;
            }

            if (vm.filters.sinceDate) {
                vm.filters.sinceDate = moment(vm.filters.sinceDate, DATE_FORMAT).format(DATE_FORMAT);
            }

            if (vm.filters.untilDate) {
                vm.filters.untilDate = moment(vm.filters.untilDate, DATE_FORMAT).format(DATE_FORMAT);
            }
        }
    }
})();
